const SERVER = null

const parser = {

  // ===========================================
  // Tests
  // ===========================================

  isSameHost (url) {
    if (!url || SERVER) return false

    const host = window.location.hostname
    const result = url.match(host)

    return result
  },

  hasHost (url) {
    if (!url || SERVER) return false

    const result = url.match(/^\/?[^:]*$/i)

    return !result
  },

  isFile (url) {
    if (!url || SERVER) return false

    return url.match(/(\/|^)[^.:\\\/]*[.]{1}[^.:\/\\]*$/i)
  },

  isOuter (url) {
    if (!url || SERVER) return false;

    const isOuter = !(this.isSameHost(url) || !this.hasHost(url));

    return isOuter
  },

  isInner (url) {
    return !this.isOuter(url) && !this.isFile(url)
  },

  isMail (url) {
    return url.match(/^mailto\:/i)
  },

  // ===========================================
  // Getters
  // ===========================================

  getTarget (url) {
    if (!url) return '_blank'

    return this.isOuter(url) || this.isFile(url) ? '_blank' : '_self'
  },

  getUrl (url) {
    if (!url || SERVER) return url

    if (this.isMail(url)) return url
    if (this.isOuter(url)) return url.search(/^http[s]?\:\/\//) === -1 ? `http://${url}` : url
    if (this.isFile(url)) return this.hasHost ? `http://${window.location.host}${url.match(/^\//) ? '' : '/'}${url}` : url

    return url
  },

  getStaticUrl (url) {
    if (!url || SERVER) return url

    if (url.match(/^\/?[a-zA-Z0-9-]*((\/.*$)|($))/gi)) {
      return `${window.location.protocol}//${window.location.host}${url.match(/^\//) ? '' : '/'}${url}`
    }

    return url.search(/^http[s]?\:\/\//) === -1 ? `http://${url}` : url
  }
}

export default parser



// WEBPACK FOOTER //
// ./src/services/url-parser.js